import { CONCEPTS } from '@rover/rsdk/src/concepts';
import { FLAGS } from '@rover/shared/js/hooks/useFlag';
import Route from '@rover/types/src/Route';

import {
  authenticated as testimonialRoutesAuthenticated,
  unauthenticated as testimonialRoutesUnauthenticated,
} from './testimonials';
import { authenticated as trainerCancellationRoutesAuthenticated } from './trainerCancellation';
import { unauthenticated as trainerContactEmbeddedSignInGateRoutesUnauthenticated } from './trainerContactEmbeddedSignInGate';
import { authenticated as trainerGatingRoutesAuthenticated } from './trainerGating';
import {
  authenticated as trainerProfileRoutesAuthenticated,
  unauthenticated as trainerProfileRoutesUnauthenticated,
} from './trainerProfile';
import { unauthenticated as trainerSearchRoutesUnauthenticated } from './trainerSearch';
import { authenticated as trainerSignUpRoutesAuthenticated } from './trainerSignUp';
import { authenticated as trainerVirtualSessionAuthenticated } from './trainerVirtualSession';
import { unauthenticated as videoLinkRedirectPageUnauthenticated } from './videoLinkRedirectPage';

export type PartialRoute = Omit<Route, 'concept' | 'isReactQueryRoute' | 'cacheTag'> & {
  cacheTag?: Route['cacheTag'];
  concept?: never;
  isReactQueryRoute?: never;
};

const authenticated: PartialRoute[] = [
  ...trainerGatingRoutesAuthenticated,
  ...testimonialRoutesAuthenticated,
  ...trainerProfileRoutesAuthenticated,
  ...trainerSignUpRoutesAuthenticated,
  ...trainerCancellationRoutesAuthenticated,
  ...trainerVirtualSessionAuthenticated,
].map(({ suppressFooter = true, ...route }) => ({
  ...route,
  suppressFooter,
  requiresAuth: true,
}));

const unauthenticated: PartialRoute[] = [
  ...trainerProfileRoutesUnauthenticated,
  ...testimonialRoutesUnauthenticated,
  ...trainerSearchRoutesUnauthenticated,
  ...trainerContactEmbeddedSignInGateRoutesUnauthenticated,
  ...videoLinkRedirectPageUnauthenticated,
].map((route) => ({
  ...route,
  requiresAuth: false,
}));

const routes: Route[] = [...authenticated, ...unauthenticated].map(({ cacheTag, ...route }) => ({
  ...route,
  concept: CONCEPTS.service_offerings.training,
  suppressAppInstallBanner: FLAGS.ROLLOUT_TRAINING_SUPPRESS_APP_INSTALL_BANNER,
  isReactQueryRoute: true,
  exact: true,
  cacheTag: [...(cacheTag || []), route.pageCategory, 'page-all'],
}));

export default routes;
